import { Flash } from "./types";

/** TODO: Replace this validator with a validator for AlertProps from Alert component */

const VALID_FLASH_KINDS = ["failure", "success", "warning", "error"] as const;

export function isValidFlash(value: unknown): value is Flash {
  if (!value || typeof value !== "object") {
    return false;
  }

  const obj = value as Record<string, unknown>;
  const keys = Object.keys(obj);

  return (
    keys.length === 2 &&
    "kind" in obj &&
    "message" in obj &&
    typeof obj.kind === "string" &&
    VALID_FLASH_KINDS.includes(obj.kind as Flash["kind"]) &&
    typeof obj.message === "string"
  );
}

export function isValidFlashes(value: unknown): value is Flash[] {
  return Array.isArray(value) && value.length > 0 && value.every(isValidFlash);
}
